import {
  AggregateVectorParameterTypeInternal,
  MeasurementChannelKind,
  OptimizerScalarParameterTypeInternal,
  OptimizerVectorParameterTypeInternal,
  ScalarParameterTypeInternal,
  VectorParameterTypeInternal,
} from '../../../../data-access/gql-types/graphql';
import { useMeasurementMapStore } from '../../store/measurement-map';

export const useMeasurementMapOperations = () => {
  const measurementMap = useMeasurementMapStore((s) => s.measurementMap);

  const convertMeterMeasurementToNumber = (
    parameter: 'scalars' | 'vectors' | 'aggregates',
    type: ScalarParameterTypeInternal | VectorParameterTypeInternal | AggregateVectorParameterTypeInternal,
  ) => {
    if (parameter === 'aggregates') return measurementMap?.meter.aggregates.find((x) => x.type === type)?.value || 0;
    if (parameter === 'scalars') return measurementMap?.meter.scalars.find((x) => x.type === type)?.value || 0;
    return measurementMap?.meter.vectors.find((x) => x.type === type)?.value || 0;
  };

  const convertOptimizerMeasurementToNumber = (
    parameter: 'scalars' | 'vectors',
    type: OptimizerScalarParameterTypeInternal | OptimizerVectorParameterTypeInternal,
  ) => {
    if (parameter === 'scalars') return measurementMap?.optimizer.scalars.find((x) => x.type === type)?.value || 0;
    return measurementMap?.optimizer.vectors.find((x) => x.type === type)?.value || 0;
  };

  const convertMeterNumberToMeasurement = (parameter: 'scalars' | 'vectors' | 'aggregates', value: number) => {
    switch (parameter) {
      case 'scalars': {
        return (
          measurementMap?.meter.scalars.find((x) => x.value.toString() === value.toString())?.type ||
          ScalarParameterTypeInternal.Unknown
        );
      }
      case 'aggregates': {
        return (
          measurementMap?.meter.aggregates.find((x) => x.value.toString() === value.toString())?.type ||
          AggregateVectorParameterTypeInternal.Unknown
        );
      }
      default: {
        return (
          measurementMap?.meter.vectors.find((x) => x.value.toString() === value.toString())?.type ||
          VectorParameterTypeInternal.Unknown
        );
      }
    }
  };

  const convertOptimizerNumberToMeasurement = (parameter: 'scalars' | 'vectors', value: number) => {
    if (parameter === 'scalars')
      return (
        measurementMap?.optimizer.scalars.find((x) => x.value.toString() === value.toString())?.type ||
        OptimizerScalarParameterTypeInternal.Unknown
      );

    return (
      measurementMap?.optimizer.vectors.find((x) => x.value.toString() === value.toString())?.type ||
      OptimizerVectorParameterTypeInternal.Unknown
    );
  };

  const convertNumberToMeasurement: any = (kind: MeasurementChannelKind) => {
    return kind === MeasurementChannelKind.Meter
      ? convertMeterNumberToMeasurement
      : convertOptimizerNumberToMeasurement;
  };

  const convertMeasurementToNumber: any = (kind: MeasurementChannelKind) => {
    return kind === MeasurementChannelKind.Meter
      ? convertMeterMeasurementToNumber
      : convertOptimizerMeasurementToNumber;
  };

  return {
    measurementMap,
    convertMeasurementToNumber,
    convertNumberToMeasurement,
  };
};
